module.exports = __webpack_public_path__ + "static/media/congratulate_map.558fa794.svg";